import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'stringJoin', pure: true })
export class StringJoinPipe implements PipeTransform {
  transform(value: readonly string[] | null | undefined, sep = ', '): string {
    return (value ?? []).join(sep);
  }
}